import React from "react"

// configs
import config from "config"

// firebase
import { Firestore } from "services/firebase"
import { getDoc, doc } from "firebase/firestore"

const RestoContext = React.createContext()

function useResto() {
  const context = React.useContext(RestoContext)
  if (!context) {
    throw new Error(`useResto must be used within a RestoProvider`)
  }

  const [resto] = context.resto

  return resto
}

function RestoProvider(props) {
  const [restoSettings, setRestoSettings] = React.useState()

  React.useEffect(() => {
    const asyncHandler = async () => {
      const settingsData = await getDoc(doc(Firestore, "public", config.key))

      if (!settingsData.exists()) return

      console.log("✅ Loaded public")

      setRestoSettings(settingsData.data())
    }

    asyncHandler()
  }, [])

  const resto = React.useMemo(
    () => [restoSettings, setRestoSettings],
    [restoSettings]
  )

  return <RestoContext.Provider value={{ resto }} {...props} />
}

export { RestoProvider, useResto }
